import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import {
  ToastService,
  ToastData,
} from '../../service/components/toast.service';
import { ToastNotificationComponent } from '../toast-notification/toast-notification.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, ToastNotificationComponent],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.css'],
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  /** Array que almacena las notificaciones toast activas */
  toasts: ToastData[] = [];

  /** Suscripción al servicio de toasts */
  private subscription?: Subscription;

  /**
   * Constructor del componente
   * @param toastService Servicio para gestionar las notificaciones toast
   */
  constructor(private toastService: ToastService) {}

  /**
   * Inicializa la suscripción al servicio de toasts
   * Se ejecuta cuando el componente se inicializa
   */
  ngOnInit(): void {
    this.subscription = this.toastService.getToasts().subscribe((toasts) => {
      this.toasts = toasts;
    });
  }

  /**
   * Limpia la suscripción cuando el componente se destruye
   * para evitar memory leaks
   */
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /**
   * Elimina una notificación toast específica
   * @param id Identificador único del toast a eliminar
   */
  removeToast(id: number): void {
    this.toastService.remove(id);
  }
}
